import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';

import {base} from '../api-config';

import {Exam, ExamEvent, ExamRequest} from '../models/exam';

const endpoint = `${base}/exams`;

@Injectable({
  providedIn: 'root'
})
export class ExamService {

  constructor(private http: HttpClient) {}

  get(id: number): Observable<Exam> {
    return this.http.get<Exam>(`${endpoint}/${id}`);
  }

  update(id: number, exam: ExamRequest): Observable<Exam> {
    return this.http.put<Exam>(`${endpoint}/${id}`, exam);
  }

  delete(id: number): Observable<string> {
    return this.http.delete<string>(`${endpoint}/${id}`);
  }

  lock(id: number): Observable<string> {
    const route = `${endpoint}/${id}/lock`;
    return this.http.get<string>(route);
  }

  unlock(id: number): Observable<string> {
    const route = `${endpoint}/${id}/unlock`;
    return this.http.get<string>(route);
  }
}
